import { numericFormatter } from 'react-number-format'

import { DEFAULT_LOCALE, SupportedLocale } from '../../constants'
import { NumericFieldDefinition } from '../../definitions'
import { tryConvertDecimalInfo } from '../../utils'
import { getSeparator } from '../../utils/number'
import { FieldValue } from './field.class'

export class NumericValue extends FieldValue<number> {
  public um: string
  public approximation?: string
  public decimalLimit?: number

  constructor(value?: number, um?: string, approximation?: string, decimalLimit?: number) {
    super()
    this.value = value
    this.um = um ?? ''
    this.approximation = approximation
    this.decimalLimit = decimalLimit
  }

  public mapField(field: NumericValue, fieldDef: NumericFieldDefinition): void {
    this.value = field.value
    this.um = field.um
    this.approximation = field.approximation
    this.decimalLimit = tryConvertDecimalInfo(
      fieldDef.decimalInfo,
      fieldDef.um,
      fieldDef.entityName,
      fieldDef.name,
      fieldDef.step,
    )?.decimalLimit
  }

  public toStringForView(lang: SupportedLocale = DEFAULT_LOCALE, um?: string): string {
    if (typeof this.value !== 'number') {
      return ''
    }

    const decimalSeparator = getSeparator(lang, 'decimal', this.value)
    const thousandSeparator = getSeparator(lang, 'group', this.value)

    const formatted = numericFormatter(`${this.value}`, {
      decimalSeparator,
      thousandSeparator,
      decimalScale: this.decimalLimit,
      allowLeadingZeros: true,
      allowNegative: true,
    })
    return um && um.trim() ? `${formatted} ${um}` : formatted
  }
}
